import React from "react";
import { useMsal } from "@azure/msal-react";
import { Button } from "../skapa/button.js";

/**
 * Renders a sign-out button
 */
export const SignOutButton = () => {
  const { instance } = useMsal();

  const handleLogout = (logoutType) => {
    if (logoutType === "redirect") {
      instance.logoutRedirect({
        postLogoutRedirectUri: "/",
      });
    }
  };

  return (
    <div className="logoutbtn">
      <Button
        class="btn btn--emphasised"
        type="primary"
        variant="secondary"
        onClick={() => handleLogout("redirect")}
        className="ml-auto"
        drop="start"
        title="Sign In"
      >
        LOGOUT
      </Button>
    </div>
  );
};